<template>
  <div
    id="isso-root"
  >
    <div
      ref="container"
      class="container"
    >
      <div
        v-for="com in comment"
        :key="com.id"
        class="comment-root"
      >
        <IssoComment
          :author="com.author"
          :created="com.created"
          :text="com.text"
          @newcom="newCom"
          @submit="submit_comment"
        />
      </div>
    </div>
    <IssoInput
      :parent="null"
      :error="submit_error"
      @submit="submit_comment"
    />
  </div>
</template>
<script>
import axios from 'axios';

export default {
  components: {
    IssoInput: () => import(/* webpackChunkName: "new-input" */ '@/components/Isso/IssoInputField.vue'),
    IssoComment: () => import(/* webpackChunkName: "new-comment" */ '@/components/Isso/IssoComment.vue'),
  },
  props: {
    title: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      comment: [],
      submit_error: null,
      scrolled: false,
      thread: this.getThread(),
      number: this.getNumber(),
      accountStatusEnabled: false,
      interval: null,
    };
  },
  mounted() {
    this.load_comments();

    this.interval = setInterval(() => {
      this.load_comments();
    }, 2500);
  },
  updated() {
    this.scrollToEnd();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    scrollToEnd() {
      this.$el.scrollTop = this.$el.lastElementChild.offsetTop;
      const container = this.$el.querySelector('.container');
      container.scrollTop = container.scrollHeight;
    },
    getThread() {
      if (this.$route.name === 'StatusAccountDetail') {
        return `/${this.$store.state.customers.temporal.customerId}/${this.$store.state.customers.temporal.companyId}`;
      } if (this.$route.name === 'CustomerEdit') {
        return `/${this.$store.state.customers.id}/${this.$store.state.customers.companyId}`;
      }
      return `/${this.$route.params.customer}/${this.$route.params.company}`;
    },
    getNumber() {
      return this.$store.state.customers.cellphoneNumber;
    },
    async load_comments() {
      const data = await axios.get(`${process.env.VUE_APP_MACHETE_ISSO_API_URL}/?uri=${this.thread}`, { validateStatus: false });

      if (this.comment.length !== data.data.replies.length) {
        this.comment = data.status === 200 ? data.data.replies : [];
      }
    },
    async send_sms(content, name) {
      try {
        await this.$store.dispatch('messages/twilio', {
          content, number: this.number, customer: this.$store.state.customers.id, author: name,
        });
        this.$success({ message: 'SMS enviado exitosamente' });
      } catch (error) {
        this.$danger({ message: error.message });
      }
    },
    submit_comment(content, name, email, sendSms) {
      if (sendSms) {
        this.send_sms(content, name);
      }

      const data = { title: this.title };
      this.submit_error = [];

      if (name) {
        data.author = name;
      }

      if (email) {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          this.submit_error.push('correo invalido. ');
        } else {
          data.email = email;
        }
      }

      if (!content || content.length < 3) {
        this.submit_error.push('El comentario debe ser de al menos 3 caracteres');
      } else {
        data.text = content;
      }

      this.submit_error = this.submit_error.join('');

      if (!this.submit_error) {
        axios
          .post(`${process.env.VUE_APP_MACHETE_ISSO_API_URL}/new?uri=${this.thread}`, data, {
            withCredentials: true,
          })
          .then((res) => {
            this.newCom(res);
          });
      }
    },
    newCom(res) {
      this.$set(this.comment, this.comment.length, res.data);

      if (!this.accountStatusEnabled && !this.$store.state.customers.accStatusToken) {
        this.enableAccountStatus();
      }
    },
    async enableAccountStatus() {
      await this.$store.dispatch(
        'customers/sendStatusAccountEmail',
        {
          customerId: this.$store.state.customers.id,
          companyId: this.$store.state.customers.companyId,
        },
      );

      this.accountStatusEnabled = true;
    },
  },
};
</script>
<style scoped>
  #isso-root {
    height: 100%;
    min-height: 215px;
    position: relative;
    padding: 0;
  }

  .comment-root {
    display: flex;
    flex-direction:column;
    align-items:flex-start;
    padding: 10px;
  }

  .container {
    overflow-y: auto;
    min-height: 100px;
    max-height: 650px;
    padding: 5px;
  }

  h2 {
    font-weight: bold;
    margin-bottom: 15px;
  }
</style>
